module.exports = __webpack_public_path__ + "586dd0c2e2c5f7f4f6e242e31fac9660.png";